import { render, staticRenderFns } from "./ViewProjectAIExpert.vue?vue&type=template&id=2f2a7c79&scoped=true"
import script from "./ViewProjectAIExpert.vue?vue&type=script&lang=js"
export * from "./ViewProjectAIExpert.vue?vue&type=script&lang=js"
import style0 from "./ViewProjectAIExpert.vue?vue&type=style&index=0&id=2f2a7c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a7c79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
